import { Component, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { environment } from '@app/env';
import { AnalyticsService } from '@app/shared/modules/analytics/services/analytics.service';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { EvsbThankYouOutboundModel } from './evsb-thank-you-outbound.model';
import { EvsbThankYouOutboundService } from './evsb-thank-you-outbound.service';

@Component({
  template: '',
})
export abstract class EvsbThankYouOutboundComponent implements OnInit, OnDestroy {
  public readonly environment = environment;
  public model: EvsbThankYouOutboundModel;

  private notifier = new Subject<void>();

  constructor(
    public translate: TranslateService,
    protected pageService: EvsbThankYouOutboundService,
    protected title: Title,
    protected analyticsService: AnalyticsService,
    protected router: Router
  ) {}

  ngOnInit(): void {
    this.translate.onLangChange.pipe(takeUntil(this.notifier)).subscribe(() => {
      this.title.setTitle(this.translate.instant('modules.evsb.pages.title.thankYouOutbound'));
    });
    this.model = this.pageService.getModel();
  }

  ngOnDestroy(): void {
    this.notifier.next();
    this.notifier.complete();
  }

  public navigate(): void {
    this.analyticsNavigate();
    window.location.href = this.model.navigation;
  }

  protected abstract analyticsNavigate();
}
